(function(){
  const qs=(s,r=document)=>r.querySelector(s);
  const qsa=(s,r=document)=>Array.from(r.querySelectorAll(s));

  // Safe storage wrapper: avoids SecurityError in private/sandboxed browsing and never blocks shopping.
  const safeStorage = (() => {
    const memory = new Map();
    const getStore = () => {
      try {
        const store = window.localStorage || window.sessionStorage;
        const testKey = '__pd_storage_test__';
        store.setItem(testKey, '1');
        store.removeItem(testKey);
        return store;
      } catch (_) {
        try { return window.sessionStorage; } catch (__) { return null; }
      }
    };
    const store = getStore();
    return {
      get: (key) => {
        try { return store ? store.getItem(key) : (memory.has(key) ? memory.get(key) : null); }
        catch (_) { return memory.has(key) ? memory.get(key) : null; }
      },
      set: (key, val) => {
        try { if (store) store.setItem(key, val); else memory.set(key, val); }
        catch (_) { memory.set(key, val); }
      },
      remove: (key) => {
        try { if (store) store.removeItem(key); else memory.delete(key); }
        catch (_) { memory.delete(key); }
      }
    };
  })();

  // Helpers
  const scheduleNonCritical = (fn, timeout = 1200) => {
    if (typeof fn !== 'function') return;
    const start = () => {
      const idle = window.requestIdleCallback || ((cb) => window.setTimeout(cb, timeout));
      idle(() => {
        try { fn(); } catch (e) { console.warn('Deferred init failed', e); }
      }, { timeout });
    };
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
  };

  const debounce = (fn, wait = 180) => {
    let t = null;
    return (...args) => {
      if (t) window.clearTimeout(t);
      t = window.setTimeout(() => fn.apply(null, args), wait);
    };
  };

  const formatMoney = (cents) => {
    try {
      const f = window.Shopify && window.Shopify.formatMoney;
      if (typeof f === 'function') {
        const fmt = window.__money_format_no_trailing;
        if (fmt) return f(cents, fmt);
        return f(cents);
      }
    } catch(e) {}

    // Fallback using Intl with currency, dropping trailing zeros
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    const value = (typeof cents === 'number' ? cents : parseInt(cents, 10)) / 100;
    try {
      // Use 0 decimals when possible (e.g. 12.00 -> 12)
      const nf = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return nf.format(value);
    } catch(e) {
      // Last resort
      const s = value.toFixed(2);
      return `${s} ${currency}`;
    }
  };

  const normalizeCurrencyCode = (value) => {
    const candidates = [
      value,
      window.Shopify && window.Shopify.currency && window.Shopify.currency.active,
      window.Shopify && window.Shopify.currency && window.Shopify.currency.default,
      'USD'
    ];
    for (const candidate of candidates) {
      const code = String(candidate || '').trim().toUpperCase();
      if (/^[A-Z]{3}$/.test(code)) return code;
    }
    return 'USD';
  };

  const sanitizeAnalyticsPayload = (payload = {}) => {
    const normalized = Object.assign({}, payload || {});
    if (Object.prototype.hasOwnProperty.call(normalized, 'currency')) {
      normalized.currency = normalizeCurrencyCode(normalized.currency);
    }
    if (normalized.ecommerce && typeof normalized.ecommerce === 'object') {
      normalized.ecommerce = Object.assign({}, normalized.ecommerce);
      if (Object.prototype.hasOwnProperty.call(normalized.ecommerce, 'currency')) {
        normalized.ecommerce.currency = normalizeCurrencyCode(normalized.ecommerce.currency);
      }
    }
    return normalized;
  };

  const publishDirectMetaEvent = (eventName, payload = {}, standard = false) => {
    try {
      if (typeof window.fbq !== 'function') return;
      const normalized = sanitizeAnalyticsPayload(payload);
      window.fbq(standard ? 'track' : 'trackCustom', eventName, normalized);
    } catch (_) { }
  };

  const suppressEmailOfferOverlay = () => {
    const offer = qs('[data-email-offer]');
    if (offer) offer.hidden = true;
    const teaser = qs('[data-email-offer-open]');
    if (teaser) teaser.setAttribute('aria-expanded', 'false');
  };

  const publishCustomCustomerEvent = async (eventName, payload = {}) => {
    try {
      const normalized = sanitizeAnalyticsPayload(payload);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, normalized));
      const publish = window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish;
      if (typeof publish === 'function') publish(eventName, normalized);
    } catch (_) {
      // Analytics should never block shopping.
    }
  };


// Randomize any grids marked for random display (homepage sections, etc.)
  const shuffleInPlace = (arr) => {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  };
  const randomizeGrid = (grid) => {
    if (!grid) return;
    const limit = parseInt(grid.getAttribute('data-limit') || '0', 10);
    const kids = Array.from(grid.children).filter(n => n.nodeType === 1);
    if (kids.length < 2) return;
    shuffleInPlace(kids);
    kids.forEach((el, idx) => {
      // Re-append in new order
      grid.appendChild(el);
      if (limit && idx >= limit) el.style.display = 'none';
      else el.style.display = '';
    });
  };
  document.addEventListener('DOMContentLoaded', () => {
    // Intentionally disabled for performance and layout stability.
  });

  // Keep announcement bar text consistent (prevents conflicting injected banners from overwriting it).
  document.addEventListener('DOMContentLoaded', () => {
    const ann = document.querySelector('.announcement[data-announcement-text]');
    if (!ann) return;
    const expected = (ann.getAttribute('data-announcement-text') || '').trim();
    const container = ann.querySelector('.container');
    if (!container || !expected) return;

    const enforce = () => {
      const current = (container.textContent || '').trim();
      if (current !== expected) container.textContent = expected;
    };

    enforce();

    try {
      const obs = new MutationObserver(() => enforce());
      obs.observe(container, { subtree: true, childList: true, characterData: true });
    } catch (e) {
      // Ignore if MutationObserver isn't supported
    }
  });
// Use Shopify native standard cart events; do not manually publish reserved event names.
const fetchCartJson = async () => {
  try {
    const res = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });
    if (!res.ok) throw new Error('cart_fetch_failed');
    return await res.json();
  } catch (e) {
    return null;
  }
};


// Cart drawer (slide-out)
  const drawer = qs('[data-cart-drawer]');
  const drawerBody = qs('[data-cart-drawer-body]');
  let drawerFooter = qs('[data-cart-drawer-footer]');
  let drawerSubtotal = qs('[data-cart-drawer-subtotal]');
  let drawerShipping = qs('[data-cart-drawer-shipping]');
  let drawerTotal = qs('[data-cart-drawer-total]');

  const syncDrawerFooterRefs = () => {
    drawerFooter = qs('[data-cart-drawer-footer]');
    drawerSubtotal = qs('[data-cart-drawer-subtotal]');
    drawerShipping = qs('[data-cart-drawer-shipping]');
    drawerTotal = qs('[data-cart-drawer-total]');
  };

  const buildDrawerFooterMarkup = () => {
    const showWhatsApp = window.__PD_ENABLE_WHATSAPP_BUTTON !== false;
    const showTrustBadges = window.__PD_ENABLE_TRUST_BADGES !== false;
    return `
      <div class="cart-drawer__footer" data-cart-drawer-footer>
        <div class="cart-drawer__subtotal">
          <span class="muted">Subtotal</span>
          <strong data-cart-drawer-subtotal></strong>
        </div>
        <div class="cart-drawer__shipping">
          <span class="muted">Flat $5 delivery</span>
          <strong data-cart-drawer-shipping></strong>
        </div>
        <div class="cart-drawer__estimated-total">
          <span class="muted">Estimated total</span>
          <strong data-cart-drawer-total></strong>
        </div>
        <div class="cart-drawer__actions" data-cart-drawer-actions>
          <div class="cart-drawer__cta-row">
            <a class="btn" href="/checkout" data-force-checkout data-checkout-cta>Checkout</a>
            ${showWhatsApp ? '<a class="btn secondary" href="#" target="_blank" rel="nofollow noopener" data-whatsapp-order data-whatsapp-source="drawer">Order Via WhatsApp</a>' : ''}
          </div>
          ${showTrustBadges ? `
            <div class="cart-drawer__reassurance" aria-label="Checkout reassurance">
              <div class="pd-trust pd-trust--drawer">
                <div class="pd-trust__item"><span>Secure checkout</span></div>
                <div class="pd-trust__item"><span>Delivery across Lebanon</span></div>
                <div class="pd-trust__item"><span>Cash on delivery (COD)</span></div>
              </div>
            </div>
          ` : ''}
        </div>
      </div>
    `;
  };

  const ensureDrawerFooter = () => {
    syncDrawerFooterRefs();
    if (drawerFooter) return drawerFooter;
    const panel = drawer ? drawer.querySelector('.cart-drawer__panel') : null;
    if (!panel) return null;
    const holder = document.createElement('div');
    holder.innerHTML = buildDrawerFooterMarkup().trim();
    const footer = holder.firstElementChild;
    if (!footer) return null;
    panel.appendChild(footer);
    syncDrawerFooterRefs();
    return drawerFooter;
  };

  const removeDrawerFooter = () => {
    syncDrawerFooterRefs();
    if (drawerFooter) drawerFooter.remove();
    syncDrawerFooterRefs();
  };

  const setDrawerFooterVisible = (show) => {
    if (show) ensureDrawerFooter();
    else removeDrawerFooter();
    if (!drawerFooter) {
      if (drawer) drawer.classList.toggle('is-empty', !show);
      return;
    }
    drawerFooter.hidden = !show;
    drawerFooter.style.display = show ? '' : 'none';
    drawerFooter.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (drawer) drawer.classList.toggle('is-empty', !show);
  };

  const hardCleanEmptyCartDrawer = () => {
    const initialCount = drawer ? parseInt(drawer.getAttribute('data-cart-initial-count') || '0', 10) : 0;
    const initialItems = window.__PD_INITIAL_CART && Array.isArray(window.__PD_INITIAL_CART.items) ? window.__PD_INITIAL_CART.items.length : initialCount;
    if (initialItems > 0) return;
    removeDrawerFooter();
    if (drawer) drawer.classList.add('is-empty');
    document.body && document.body.classList.remove('cart-has-items');
    qsa('[data-cart-presence-gated]').forEach((el) => el.remove());
  };
  hardCleanEmptyCartDrawer();
  let drawerCloseTimer = null;
  const openDrawer = () => {
    if (!drawer) return;
    suppressEmailOfferOverlay();
    if (drawerCloseTimer) {
      window.clearTimeout(drawerCloseTimer);
      drawerCloseTimer = null;
    }
    drawer.hidden = false;
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden','false');
      document.documentElement.classList.add('cart-drawer-open');
    });
  };

  document.addEventListener('click', (e) => {
    const link = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!link) return;
    try {
      const url = new URL(link.href, window.location.origin);
      const samePath = url.origin === window.location.origin && url.pathname.replace(/\/$/, '') === '/cart';
      if (!samePath) return;
      e.preventDefault();
      openDrawer();
      refreshDrawer();
    } catch(_) {}
  });
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('cart-drawer-open');
    if (drawerCloseTimer) window.clearTimeout(drawerCloseTimer);
    drawerCloseTimer = window.setTimeout(() => {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 280);
  };
  qsa('[data-cart-drawer-close]').forEach(el=>el.addEventListener('click', closeDrawer));
  document.addEventListener('click', (e) => {
    const closeBtn = e.target && e.target.closest ? e.target.closest('[data-cart-drawer-close]') : null;
    if (!closeBtn) return;
    closeDrawer();
  });
  document.addEventListener('keydown', (e)=>{ if(e.key==='Escape') { closeDrawer(); closeQuickAdd && closeQuickAdd(); } });

  const createCheckoutFloat = () => {
    const fabRow = qs('[data-pd-fab-row]');
    if (!fabRow || qs('[data-cart-presence-gated]')) return;
    const checkout = document.createElement('a');
    checkout.className = 'pd-checkout-float';
    checkout.setAttribute('data-cart-presence-gated', '');
    checkout.setAttribute('href', '/checkout');
    checkout.setAttribute('data-force-checkout', '');
    checkout.setAttribute('aria-label', 'Checkout');
    checkout.innerHTML = '<span class="pd-checkout-float__label">Checkout</span>';
    const waFloat = qs('[data-pd-wa-float]', fabRow);
    if (waFloat) fabRow.insertBefore(checkout, waFloat);
    else fabRow.appendChild(checkout);
  };

  const setCartPresenceUI = (cart) => {
    const hasItems = !!(cart && Array.isArray(cart.items) && cart.items.length);
    document.body && document.body.classList.toggle('cart-has-items', hasItems);
    if (hasItems) createCheckoutFloat();
    qsa('[data-cart-presence-gated]').forEach((el) => {
      if (!hasItems) {
        el.remove();
        return;
      }
      el.hidden = false;
      el.removeAttribute('aria-hidden');
      el.removeAttribute('aria-disabled');
    });
  };

  const renderDrawer = (cart) => {
    if (!drawerBody) return;
    window.__PD_INITIAL_CART = cart || { items: [] };
    const hasItems = !!(cart && Array.isArray(cart.items) && cart.items.length);
    if (!hasItems){
      drawerBody.innerHTML = `
        <div class="cart-empty-state" data-cart-empty-state>
          <p class="cart-empty-state__title">Your cart is empty</p>
          <a class="btn secondary" href="/collections/all" data-cart-drawer-close>Continue shopping</a>
        </div>
      `;
      setDrawerFooterVisible(false);
      setCartPresenceUI(cart);
      updateWhatsAppOrderLink(cart);
      return;
    }
    const rows = cart.items.map((it, idx)=>{
      const imgUrl = (it.image && typeof it.image === "string") ? (it.image.includes("cdn.shopify.com") ? (it.image + (it.image.includes("?") ? "&" : "?") + "width=220&height=220&crop=center&format=webp") : it.image) : null;
      const img = imgUrl ? `<img src="${imgUrl}" alt="" loading="lazy" decoding="async" width="72" height="72">` : '';
      const qty = it.quantity || 1;
      const unit = (typeof it.final_price === 'number') ? it.final_price : (typeof it.price === 'number' ? it.price : 0);
      const linePrice = typeof it.final_line_price === 'number' ? it.final_line_price : (unit * qty);
      const line = idx + 1;
      const title = it.product_title || it.title || 'Item';
      const variantTitle = cleanVariantTitle(it.variant_title || '');
      const url = it.url || '#';
      const safeTitle = String(title).replace(/[&<>"]/g, (ch) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch]));
      const safeVariant = String(variantTitle).replace(/[&<>"]/g, (ch) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch]));
      return `
        <div class="cart-drawer__item">
          <div class="cart-drawer__item-media-col">
            <div class="cart-drawer__item-media">${img}</div>
            <button class="cart-drawer__remove cart-drawer__remove--mobile" type="button" aria-label="Remove ${safeTitle} from cart" data-cart-remove-line="${line}">Remove</button>
          </div>
          <div class="cart-drawer__item-info">
            <div class="cart-drawer__item-topline">
              <a class="cart-drawer__item-title" href="${url}">${safeTitle}</a>
              <button class="cart-drawer__remove cart-drawer__remove--desktop" type="button" aria-label="Remove ${safeTitle} from cart" data-cart-remove-line="${line}">Remove</button>
            </div>
            ${safeVariant ? `<div class="cart-drawer__item-variant">${safeVariant}</div>` : ''}
            <div class="cart-drawer__item-pricing" aria-label="Item pricing details">
              <span class="cart-drawer__item-qtyunit">${qty} × ${formatMoney(unit)}</span>
              <span class="cart-drawer__item-total">${formatMoney(linePrice)}</span>
            </div>
          </div>
        </div>
      `;
    }).join('');
    drawerBody.innerHTML = `<div class="cart-drawer__items">${rows}</div>`;
    setDrawerFooterVisible(true);
    syncDrawerFooterRefs();
    if (drawerSubtotal) drawerSubtotal.textContent = formatMoney(cart.items_subtotal_price || 0);
    if (drawerShipping) drawerShipping.textContent = formatMoney(500);
    if (drawerTotal) drawerTotal.textContent = formatMoney((cart.items_subtotal_price || 0) + 500);
    setCartPresenceUI(cart);
    updateWhatsAppOrderLink(cart);
  };

  const getWhatsAppPhone = () => {
    return (window.__PD_WA_PHONE || '').replace(/\D/g,'') || '96176783411';
  };

  const cleanVariantTitle = (value) => {
    const text = String(value || '').replace(/\s+—\s+Sold out$/i, '').trim();
    if (!text || /^default title$/i.test(text)) return '';
    return text;
  };

  const parseVariantData = () => {
    const el = qs('[data-pd-variant-data]');
    if (!el) return [];
    try { return JSON.parse(el.textContent || '[]'); } catch(_) { return []; }
  };

  const getVariantMeta = (variantId) => {
    const items = parseVariantData();
    return items.find((item) => String(item.id) === String(variantId)) || null;
  };

  const normalizeOrderItem = (it) => {
    if (!it) return null;
    const title = String(it.product_title || it.title || 'Item').trim();
    const variantTitle = cleanVariantTitle(it.variant_title || (it.variant && it.variant.title) || it.variantTitle || it.variant_name || '');
    const quantity = Math.max(1, parseInt(it.quantity || '1', 10) || 1);
    const unitPriceCents = typeof it.final_price === 'number'
      ? it.final_price
      : (typeof it.price_cents === 'number'
          ? it.price_cents
          : (typeof it.price === 'number' ? it.price : 0));
    const linePriceCents = typeof it.final_line_price === 'number'
      ? it.final_line_price
      : (typeof it.line_price_cents === 'number' ? it.line_price_cents : (unitPriceCents * quantity));
    const variantId = it.variant_id || it.variantId || it.id || '';
    const key = [title.toLowerCase(), variantTitle.toLowerCase(), String(variantId || ''), String(unitPriceCents || 0)].join('||');
    return { key, title, variantTitle, quantity, unitPriceCents, linePriceCents, variantId };
  };

  const mergeOrderItems = (items) => {
    const merged = new Map();
    (items || []).forEach((raw) => {
      const item = normalizeOrderItem(raw);
      if (!item) return;
      if (!merged.has(item.key)) {
        merged.set(item.key, { ...item });
        return;
      }
      const existing = merged.get(item.key);
      existing.quantity += item.quantity;
      existing.linePriceCents += item.linePriceCents;
      merged.set(item.key, existing);
    });
    return Array.from(merged.values());
  };

  const buildWhatsAppFallbackMessage = () => {
    const root = qs('[data-main-product][data-product-title]');
    const title = root ? (root.getAttribute('data-product-title') || '').trim() : '';
    const url = window.location.href;
    if (title) return `Hello! I need help with this item from Petit Détail:
- ${title}
${url}`;
    return `Hello! I need help with my order from Petit Détail.
${url}`;
  };

  const buildWhatsAppCartMessage = (cart, extraItems = []) => {
    try{
      const rawItems = [];
      if (cart && Array.isArray(cart.items)) rawItems.push(...cart.items);
      if (Array.isArray(extraItems) && extraItems.length) rawItems.push(...extraItems);
      const items = mergeOrderItems(rawItems);
      if (!items.length) return buildWhatsAppFallbackMessage();
      const subtotalCents = items.reduce((sum, item) => sum + (item.linePriceCents || (item.unitPriceCents * item.quantity)), 0);
      const deliveryCents = 500;
      const lines = [];
      lines.push('Hello! I want to place this WhatsApp order:');
      items.forEach((item) => {
        const label = [`- ${item.quantity} × ${item.title}`];
        if (item.variantTitle) label.push(`(${item.variantTitle})`);
        label.push(`— ${formatMoney(item.linePriceCents || (item.unitPriceCents * item.quantity))}`);
        lines.push(label.join(' '));
      });
      lines.push(`Subtotal: ${formatMoney(subtotalCents)}`);
      lines.push(`Flat $5 delivery: ${formatMoney(deliveryCents)}`);
      lines.push(`Total with delivery: ${formatMoney(subtotalCents + deliveryCents)}`);
      lines.push('Payment: Cash on delivery (COD)');
      lines.push('Store: Petit Détail');
      return lines.join('\n');
    }catch(_){
      return buildWhatsAppFallbackMessage();
    }
  };

  const getProductWhatsAppDetails = () => {
    const root = qs('[data-main-product][data-product-title]');
    if (!root) return null;
    const form = root.querySelector('form[action*="/cart/add"]') || root.querySelector('form');
    const title = (root.getAttribute('data-product-title') || '').trim() || document.title || 'Product';
    const qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
    const rawQty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
    const quantity = Number.isFinite(rawQty) && rawQty > 0 ? rawQty : 1;
    const variantSelect = form ? form.querySelector('select[name="id"]') : null;
    const variantInput = form ? form.querySelector('input[name="id"]') : null;
    const variantId = variantSelect ? variantSelect.value : (variantInput ? variantInput.value : '');
    let variantTitle = '';
    if (variantSelect){
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      variantTitle = cleanVariantTitle(selectedOption ? selectedOption.textContent : '');
    } else if (variantInput){
      variantTitle = cleanVariantTitle(root.getAttribute('data-default-variant-title') || '');
    }
    const variantMeta = getVariantMeta(variantId);
    const priceCents = variantMeta && typeof variantMeta.price_cents === 'number' ? variantMeta.price_cents : 0;
    return { title, quantity, variantTitle, variantId, price_cents: priceCents, line_price_cents: priceCents * quantity };
  };

  const buildWhatsAppProductMessage = () => {
    const details = getProductWhatsAppDetails();
    if (!details) return buildWhatsAppFallbackMessage();
    return buildWhatsAppCartMessage(null, [details]);
  };

  const buildWhatsAppProductCartMessage = (cart) => {
    // Product-page WhatsApp should reflect the real cart when the cart has items.
    // If the cart is empty, fall back to the currently selected product/variant.
    if (cart && Array.isArray(cart.items) && cart.items.length) return buildWhatsAppCartMessage(cart);
    const details = getProductWhatsAppDetails();
    if (!details) return buildWhatsAppCartMessage(cart);
    return buildWhatsAppCartMessage(null, [details]);
  };

  const buildWhatsAppAvailabilityMessage = () => {
    const root = qs('[data-main-product][data-product-title]');
    const details = getProductWhatsAppDetails();
    const title = details && details.title ? details.title : (root ? (root.getAttribute('data-product-title') || '').trim() : document.title || 'Product');
    const variantTitle = details && details.variantTitle ? cleanVariantTitle(details.variantTitle) : '';
    const url = root && root.getAttribute('data-product-url') ? root.getAttribute('data-product-url') : window.location.href;
    const lines = [
      'Hello Petit Détail, I would like to ask about availability for:',
      `Product: ${title}`
    ];
    if (variantTitle && variantTitle.toLowerCase() !== 'default title') lines.push(`Variant: ${variantTitle}`);
    if (url) lines.push(`Link: ${url}`);
    lines.push('', 'Please let me know if it can be ordered again.');
    return lines.join('\n');
  };

  const getWhatsAppOrderItemsForLink = (link, cart) => {
    const source = (link && link.getAttribute('data-whatsapp-source')) || '';
    const details = getProductWhatsAppDetails();
    const rawItems = [];

    if (source === 'product') {
      if (details) rawItems.push(details);
      return mergeOrderItems(rawItems);
    }

    if (source === 'product-cart' || source === 'smart') {
      // Prefer the actual cart when it has items to avoid double-counting the current product.
      if (cart && Array.isArray(cart.items) && cart.items.length) rawItems.push(...cart.items);
      else if (details) rawItems.push(details);
      return mergeOrderItems(rawItems);
    }

    if (cart && Array.isArray(cart.items) && cart.items.length) rawItems.push(...cart.items);
    else if (details) rawItems.push(details);

    return mergeOrderItems(rawItems);
  };

  const calculateWhatsAppOrderTotals = (link, cart) => {
    const source = (link && link.getAttribute('data-whatsapp-source')) || '';
    if (source === 'availability') return null;
    const items = getWhatsAppOrderItemsForLink(link, cart);
    if (!items.length) return null;
    const subtotalCents = items.reduce((sum, item) => sum + (item.linePriceCents || (item.unitPriceCents * item.quantity) || 0), 0);
    const deliveryCents = 500;
    return {
      items,
      subtotalCents,
      deliveryCents,
      totalCents: subtotalCents + deliveryCents
    };
  };

  const buildWhatsAppAnalyticsPayload = (link, cart) => {
    const payload = {
      source: link ? (link.getAttribute('data-whatsapp-source') || 'unknown') : 'unknown',
      currency: normalizeCurrencyCode()
    };
    const totals = calculateWhatsAppOrderTotals(link, cart);
    if (!totals) return payload;
    payload.value = Number((totals.totalCents / 100).toFixed(2));
    payload.item_count = totals.items.reduce((sum, item) => sum + item.quantity, 0);
    payload.content_ids = totals.items.map((item) => item.variantId).filter(Boolean).map(String);
    payload.content_name = totals.items.map((item) => item.title).filter(Boolean).join(', ');
    payload.contents = totals.items.map((item) => ({
      id: String(item.variantId || item.title),
      quantity: item.quantity,
      item_price: Number((item.unitPriceCents / 100).toFixed(2))
    }));
    return payload;
  };

  const buildWhatsAppMessageForLink = (link, cart) => {
    const source = (link && link.getAttribute('data-whatsapp-source')) || '';
    if (link && link.matches && link.matches('[data-pd-wa-float]')) return buildWhatsAppFallbackMessage();
    if (source === 'availability') return buildWhatsAppAvailabilityMessage();
    if (source === 'product') return buildWhatsAppProductMessage();
    if (source === 'product-cart') return buildWhatsAppProductCartMessage(cart);
    if (source === 'smart') {
      const details = getProductWhatsAppDetails();
      if (details) return buildWhatsAppProductCartMessage(cart);
      if (cart && Array.isArray(cart.items) && cart.items.length) return buildWhatsAppCartMessage(cart);
      return buildWhatsAppFallbackMessage();
    }
    if (cart && Array.isArray(cart.items) && cart.items.length) return buildWhatsAppCartMessage(cart);
    return buildWhatsAppFallbackMessage();
  };

  const appendWhatsAppCustomerDetails = (message, customer) => {
    if (!customer) return message;
    const name = String(customer.name || '').trim();
    const address = String(customer.address || '').trim();
    const city = String(customer.city || '').trim();
    if (!name && !address && !city) return message;
    const lines = [message, '', 'Customer details:'];
    if (name) lines.push(`Name: ${name}`);
    if (address) lines.push(`Address: ${address}`);
    if (city) lines.push(`City: ${city}`);
    lines.push('Country: Lebanon');
    return lines.join('\n');
  };

  const getWhatsAppHref = (link, cart, customer = null) => {
    const phone = getWhatsAppPhone();
    const baseMessage = buildWhatsAppMessageForLink(link, cart);
    const msg = encodeURIComponent(appendWhatsAppCustomerDetails(baseMessage, customer));
    return `https://wa.me/${phone}?text=${msg}`;
  };

  const updateWhatsAppOrderLink = (cart) => {
    const links = qsa('[data-whatsapp-order], [data-pd-wa-float]');
    if (!links.length) return;
    links.forEach((link) => {
      link.href = getWhatsAppHref(link, cart || window.__PD_INITIAL_CART || null);
    });
  };

  const syncWhatsAppCartState = async () => {
    const cart = await fetchCartJson();
    if (cart && Array.isArray(cart.items)) {
      window.__PD_INITIAL_CART = cart;
      setCartPresenceUI(cart);
      updateWhatsAppOrderLink(cart);
      return cart;
    }
    return window.__PD_INITIAL_CART || null;
  };

  window.PDWhatsApp = window.PDWhatsApp || {};
  window.PDWhatsApp.getHref = (link, customer = null) => getWhatsAppHref(link, window.__PD_INITIAL_CART || null, customer);
  window.PDWhatsApp.refresh = (cart) => updateWhatsAppOrderLink(cart);

  updateWhatsAppOrderLink(window.__PD_INITIAL_CART || null);
  setCartPresenceUI(window.__PD_INITIAL_CART || null);

  document.addEventListener('change', (e) => {
    const target = e.target;
    if (!target) return;
    if (target.matches('select[name="id"], input[name="quantity"]')) {
      updateWhatsAppOrderLink(window.__PD_INITIAL_CART || null);
    }
  });

  const WA_CUSTOMER_STORAGE_KEY = 'pd_whatsapp_customer_details';
  let activeWhatsAppOrderLink = null;

  const getSavedWhatsAppCustomer = () => {
    try{
      const raw = safeStorage.get(WA_CUSTOMER_STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    }catch(_){ return {}; }
  };

  const saveWhatsAppCustomer = (customer) => {
    try{ safeStorage.set(WA_CUSTOMER_STORAGE_KEY, JSON.stringify(customer || {})); }catch(_){ }
  };

  const ensureWhatsAppOrderModal = () => {
    let modal = qs('[data-wa-order-modal]');
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'pd-wa-order-modal';
    modal.setAttribute('data-wa-order-modal', '');
    modal.hidden = true;
    modal.innerHTML = `
      <div class="pd-wa-order-modal__backdrop" data-wa-order-close aria-hidden="true"></div>
      <div class="pd-wa-order-modal__panel" role="dialog" aria-modal="true" aria-labelledby="PdWaOrderTitle">
        <button class="pd-wa-order-modal__close" type="button" data-wa-order-close aria-label="Close WhatsApp order form">×</button>
        <p class="pd-wa-order-modal__eyebrow">WhatsApp order</p>
        <h3 class="pd-wa-order-modal__title" id="PdWaOrderTitle">Add your delivery details</h3>
        <p class="pd-wa-order-modal__text">Fill this once and your details will be added to the WhatsApp message automatically.</p>
        <form class="pd-wa-order-modal__form" data-wa-order-form>
          <label class="pd-wa-order-modal__field">
            <span>Full name</span>
            <input type="text" name="name" autocomplete="name" required placeholder="Your name">
          </label>
          <label class="pd-wa-order-modal__field">
            <span>Address</span>
            <textarea name="address" rows="3" autocomplete="street-address" required placeholder="Building, street, floor, nearby landmark"></textarea>
          </label>
          <label class="pd-wa-order-modal__field">
            <span>City</span>
            <input type="text" name="city" autocomplete="address-level2" required placeholder="Beirut, Jounieh, Tripoli...">
          </label>
          <label class="pd-wa-order-modal__field">
            <span>Country</span>
            <input type="text" name="country" value="Lebanon" readonly>
          </label>
          <div class="pd-wa-order-modal__summary" data-wa-order-summary hidden></div>
          <button class="btn pd-wa-order-modal__submit" type="submit">Continue to WhatsApp</button>
          <p class="pd-wa-order-modal__note">Your WhatsApp message will include your products, delivery fee, total, and address.</p>
        </form>
      </div>`;
    document.body.appendChild(modal);

    modal.addEventListener('click', (event) => {
      if (event.target && event.target.closest && event.target.closest('[data-wa-order-close]')) {
        event.preventDefault();
        closeWhatsAppOrderModal();
      }
    });

    const form = modal.querySelector('[data-wa-order-form]');
    if (form) {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const formData = new FormData(form);
        const customer = {
          name: String(formData.get('name') || '').trim(),
          address: String(formData.get('address') || '').trim(),
          city: String(formData.get('city') || '').trim(),
          country: 'Lebanon'
        };
        if (!customer.name || !customer.address || !customer.city) {
          form.reportValidity && form.reportValidity();
          return;
        }
        saveWhatsAppCustomer(customer);
        const orderLink = activeWhatsAppOrderLink;
        const orderCart = window.__PD_INITIAL_CART || null;
        const href = getWhatsAppHref(orderLink, orderCart, customer);
        const eventPayload = buildWhatsAppAnalyticsPayload(orderLink, orderCart);
        publishCustomCustomerEvent('whatsapp_order_submitted', eventPayload);
        publishDirectMetaEvent('WhatsAppOrderSubmitted', eventPayload);
        publishDirectMetaEvent('Contact', eventPayload, true);
        closeWhatsAppOrderModal();
        window.open(href, '_blank', 'noopener');
      });
    }
    return modal;
  };

  function closeWhatsAppOrderModal(){
    const modal = qs('[data-wa-order-modal]');
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('pd-wa-order-modal-open');
    activeWhatsAppOrderLink = null;
  }

  const openWhatsAppOrderModal = (link, cartOverride = null) => {
    activeWhatsAppOrderLink = link || null;
    suppressEmailOfferOverlay();

    // The WhatsApp form must be the only overlay on screen.
    // Hide the cart drawer immediately so it cannot sit above the form.
    if (drawer) {
      closeDrawer();
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.hidden = true;
      document.documentElement.classList.remove('cart-drawer-open');
    }

    const modal = ensureWhatsAppOrderModal();
    const saved = getSavedWhatsAppCustomer();
    const nameInput = modal.querySelector('input[name="name"]');
    const addressInput = modal.querySelector('textarea[name="address"]');
    const cityInput = modal.querySelector('input[name="city"]');
    const summary = modal.querySelector('[data-wa-order-summary]');
    if (nameInput && saved.name) nameInput.value = saved.name;
    if (addressInput && saved.address) addressInput.value = saved.address;
    if (cityInput && saved.city) cityInput.value = saved.city;

    const totals = calculateWhatsAppOrderTotals(activeWhatsAppOrderLink, cartOverride || window.__PD_INITIAL_CART || null);
    if (summary && totals) {
      summary.hidden = false;
      summary.innerHTML = `
        <div class="pd-wa-order-modal__summary-row"><span>Subtotal</span><strong>${formatMoney(totals.subtotalCents)}</strong></div>
        <div class="pd-wa-order-modal__summary-row"><span>Flat $5 delivery</span><strong>${formatMoney(totals.deliveryCents)}</strong></div>
        <div class="pd-wa-order-modal__summary-row pd-wa-order-modal__summary-row--total"><span>Total</span><strong>${formatMoney(totals.totalCents)}</strong></div>
      `;
    } else if (summary) {
      summary.hidden = true;
      summary.innerHTML = '';
    }

    modal.hidden = false;
    document.documentElement.classList.add('pd-wa-order-modal-open');
    setTimeout(() => { if (nameInput) nameInput.focus(); }, 0);
  };

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeWhatsAppOrderModal();
  });

  document.addEventListener('click', async (e)=>{
    const link = e.target && e.target.closest ? e.target.closest('[data-whatsapp-order], [data-pd-wa-float]') : null;
    if (!link) return;
    e.preventDefault();
    e.stopImmediatePropagation && e.stopImmediatePropagation();
    if (link.matches && link.matches('[data-pd-wa-float]')) {
      link.href = getWhatsAppHref(link, window.__PD_INITIAL_CART || null);
      window.open(link.href, '_blank', 'noopener');
      try{
        await publishCustomCustomerEvent('whatsapp_help_clicked', {
          source: 'floating'
        });
      }catch(_){ }
      return;
    }
    const freshCart = await syncWhatsAppCartState();
    link.href = getWhatsAppHref(link, freshCart || window.__PD_INITIAL_CART || null);
    if ((link.getAttribute('data-whatsapp-source') || '') === 'availability') {
      window.open(link.href, '_blank', 'noopener');
      try{
        await publishCustomCustomerEvent('whatsapp_availability_clicked', {
          source: 'availability'
        });
      }catch(_){ }
      return;
    }
    openWhatsAppOrderModal(link, freshCart);
    try{
      const eventPayload = buildWhatsAppAnalyticsPayload(link, freshCart || window.__PD_INITIAL_CART || null);
      await publishCustomCustomerEvent('whatsapp_order_clicked', eventPayload);
      publishDirectMetaEvent('WhatsAppOrderStarted', eventPayload);
    }catch(_){ }
  });

// Remove item from drawer
  if (drawer){
    drawer.addEventListener('click', async (e)=>{
      const btn = e.target && e.target.closest ? e.target.closest('[data-cart-remove-line]') : null;
      if (!btn) return;
      e.preventDefault();
      const line = parseInt(btn.getAttribute('data-cart-remove-line') || '0', 10);
      if (!line) return;
      btn.disabled = true;
      const _prevText = btn.textContent;
      try{
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ line, quantity: 0 })
        });
        if (!res.ok) throw new Error('cart_change_failed');
        await refreshDrawer();
      }catch(e){
        btn.disabled = false;
        btn.textContent = _prevText;
        notifyCartError('Could not remove item from cart. Please try again.');
      }
    });
  }

  const refreshDrawer = async () => {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      renderDrawer(cart);
      return cart;
    } catch(e) {
      window.__PD_INITIAL_CART = { items: [] };
      if (drawerBody) drawerBody.innerHTML = '<p class="muted" style="margin:0">Could not load cart. Please refresh.</p>';
      setDrawerFooterVisible(false);
      setCartPresenceUI(window.__PD_INITIAL_CART);
      updateWhatsAppOrderLink(window.__PD_INITIAL_CART);
    }
  };

  // Quick add (product grid + featured grid)
  const quickAdd = qs('[data-quick-add]');
  const quickAddTitle = qs('[data-quick-add-title]');
  const quickAddPrice = qs('[data-quick-add-price]');
  const quickAddContent = qs('[data-quick-add-content]');
  const quickAddConfirm = qs('[data-quick-add-confirm]');
  const quickAddVariantInput = qs('[data-quick-add-variant-id]');
  let quickAddState = { product: null, selections: [], variant: null, sourceBtn: null };
  const productCache = new Map();

  const openQuickAdd = () => {
    if (!quickAdd) return;
    quickAdd.classList.add('is-open');
    quickAdd.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('quick-add-open');
  };
  const closeQuickAdd = () => {
    if (!quickAdd) return;
    quickAdd.classList.remove('is-open');
    quickAdd.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('quick-add-open');
    quickAddState = { product: null, selections: [], variant: null, sourceBtn: null };
    if (quickAddContent) quickAddContent.innerHTML = '';
    if (quickAddConfirm){
      quickAddConfirm.disabled = true;
      quickAddConfirm.textContent = 'Add';
    }
  };
  qsa('[data-quick-add-close]').forEach(el=>el.addEventListener('click', closeQuickAdd));

  const fetchProduct = async (handle) => {
    if (productCache.has(handle)) return productCache.get(handle);
    try {
      const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Product fetch failed');
      const json = await res.json();
      productCache.set(handle, json);
      return json;
    } catch (e) {
      // User-friendly message + rethrow so caller can bail.
      notifyCartError('Could not load product details. Please refresh and try again.');
      throw e;
    }
  };

  const findVariant = (product, selections) => {
    if (!product || !Array.isArray(product.variants)) return null;
    return product.variants.find(v => {
      // Shopify product.js variants include option1/2/3
      const opts = [v.option1, v.option2, v.option3].filter(Boolean);
      for (let i = 0; i < selections.length; i++){
        if (!selections[i] || selections[i] !== opts[i]) return false;
      }
      return true;
    }) || null;
  };

  const renderOptions = (product) => {
    if (!quickAddContent) return;
    const options = product.options || [];
    quickAddContent.innerHTML = options.map((optName, idx)=>{
      // Defensive: sometimes options could be objects.
      const label = (typeof optName === 'string') ? optName : (optName && optName.name ? optName.name : String(optName || ''));
      const hideLabel = String(label || '').trim().toLowerCase() === 'size';
      const values = (product.variants || [])
        .map(v => [v.option1, v.option2, v.option3][idx])
        .filter(Boolean);
      const uniq = Array.from(new Set(values));
      const btns = uniq.map(val=>{
        const safe = String(val).replace(/"/g,'&quot;');
        return `<button type="button" class="quick-add__opt" data-qa-opt data-qa-idx="${idx}" data-qa-val="${safe}" aria-label="${label}: ${safe}">${safe}</button>`;
      }).join('');
      return `
        <div class="quick-add__group" role="group" aria-label="${label}">
          ${hideLabel ? '' : `<div class="quick-add__label">${label}</div>`}
          <div class="quick-add__opts">${btns}</div>
        </div>
      `;
    }).join('');
  };

  const updateQuickAdd = () => {
    const p = quickAddState.product;
    if (!p) return;
    const v = findVariant(p, quickAddState.selections);
    quickAddState.variant = v;
    if (quickAddVariantInput) quickAddVariantInput.value = (v && v.id) ? String(v.id) : '';
    // Price display
    if (quickAddPrice){
      const cents = (v && typeof v.price === 'number') ? v.price : (p.price || 0);
      quickAddPrice.textContent = cents ? formatMoney(cents) : '';
    }
    if (quickAddConfirm){
      if (v && v.available){
        quickAddConfirm.disabled = false;
        quickAddConfirm.textContent = 'Add';
      } else if (v && !v.available){
        quickAddConfirm.disabled = true;
        quickAddConfirm.textContent = 'Sold out';
      } else {
        quickAddConfirm.disabled = true;
        quickAddConfirm.textContent = 'Add';
      }
    }
  };

  if (quickAdd){
    quickAdd.addEventListener('click', (e)=>{
      const optBtn = e.target.closest('[data-qa-opt]');
      if (!optBtn) return;
      const idx = parseInt(optBtn.getAttribute('data-qa-idx')||'0',10);
      const val = optBtn.getAttribute('data-qa-val') || '';
      quickAddState.selections[idx] = val;
      // Toggle active state
      qsa(`[data-qa-opt][data-qa-idx="${idx}"]`, quickAdd).forEach(b=>b.classList.toggle('is-active', b===optBtn));
      updateQuickAdd();
    });
  }

  const addVariantToCart = async (variantId, btn, quantity = 1) => {
    if (!variantId) return;
    if (btn){
      btn.disabled = true;
      btn.dataset.prevText = btn.textContent;
      btn.textContent = 'Adding…';
    }

    // Open the drawer immediately for a faster perceived response.
    // We'll refresh the cart contents as soon as the add completes.
    if (drawerBody){
      drawerBody.innerHTML = '<p class="muted" style="margin:0">Updating cart…</p>';
    }
    openDrawer();

    // Restore the button label once the drawer has started sliding in.
    // Keep it disabled until the request finishes to prevent double-adds.
    if (btn){
      const _prev = btn.dataset.prevText || btn.textContent;
      window.setTimeout(()=>{
        if (btn && btn.disabled) btn.textContent = _prev;
      }, 250);
    }
    try {
      const formData = new URLSearchParams();
      formData.set('id', variantId);
      formData.set('quantity', String(quantity || 1));
      // IMPORTANT: Shop Events listener expects request body to be a *string* (it calls `.split()` internally).
      // If we pass an object (URLSearchParams/FormData/etc.), it can trigger "body.split is not a function".
      // Convert params to a URL-encoded string before sending.
      const bodyString = typeof formData === 'string'
        ? formData
        : (formData instanceof FormData
            ? new URLSearchParams(formData).toString()
            : new URLSearchParams(formData).toString());
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        // Use `formData` instead of `body` to avoid conflicts with Shop Pay / Shop Events listeners.
        body: bodyString,
        credentials: 'same-origin'
      });
      if (!res.ok) throw new Error('cart_add_failed');
      const addedLineItem = await res.json();
      await refreshDrawer();
      await publishCustomCustomerEvent('add_to_cart', {
        ecommerce: {
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
          items: [{
            item_id: addedLineItem.variant_id || addedLineItem.id,
            item_name: addedLineItem.product_title || addedLineItem.title,
            item_variant: addedLineItem.variant_title || '',
            price: ((addedLineItem.price || 0) / 100),
            quantity: addedLineItem.quantity || quantity || 1
          }]
        }
      });
      // Shopify emits its own standard add-to-cart event.
    } catch(e) {
      notifyCartError('Could not add this item to your cart. Please try again.');
    } finally {
      if (btn){
        btn.disabled = false;
        btn.textContent = btn.dataset.prevText || btn.textContent;
        delete btn.dataset.prevText;
      }
    }
  };

  // Generic AJAX add-to-cart forms.
  // - Explicit: forms marked with [data-ajax-atc]
  // - Product page: Shopify product form inside [data-main-product]
  document.addEventListener('submit', async (e)=>{
    const form = e.target && e.target.closest ? e.target.closest('form[data-ajax-atc], [data-main-product] form[action^="/cart/add"]') : null;
    if (!form) return;
    e.preventDefault();
    const idSelect = form.querySelector('select[name="id"]');
    const idInput = form.querySelector('input[name="id"]');
    const variantId = (idSelect && idSelect.value) ? idSelect.value : (idInput ? idInput.value : null);
    const qtyInput = form.querySelector('input[name="quantity"]');
    const qty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
    const btn = form.querySelector('button[type="submit"]');
    await addVariantToCart(variantId, btn, isNaN(qty) ? 1 : qty);
  });

  // Product checkout: add the selected variant before navigating.
  // A failed add must NEVER send a customer to an empty checkout.
  document.addEventListener('click', async (e) => {
    const btn = e.target && e.target.closest
      ? e.target.closest('[data-buy-now], [data-checkout-now]')
      : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    const form = btn.closest('form');
    const row = btn.closest('.product-checkout-row') || btn.parentElement;
    const setError = (message) => {
      if (!row) return;
      let note = row.parentElement && row.parentElement.querySelector('[data-pd-checkout-error]');
      if (!note && message) {
        note = document.createElement('p');
        note.setAttribute('data-pd-checkout-error', '');
        note.setAttribute('role', 'alert');
        note.style.cssText = 'color:#a32b2b;font-size:13px;line-height:1.45;margin:8px 0 0;';
        row.insertAdjacentElement('afterend', note);
      }
      if (note) {
        note.textContent = message || '';
        note.hidden = !message;
      }
    };
    setError('');

    // Never silently proceed without a product or selected variant.
    if (!form) {
      setError('Please open the product page and select your item before checkout.');
      return;
    }
    const idSelect = form.querySelector('select[name="id"]');
    const idInput = form.querySelector('input[name="id"]');
    const variantId = (idSelect && idSelect.value) || (idInput && idInput.value) || '';
    if (!variantId) {
      setError('Please select an available option before checkout.');
      return;
    }
    const qtyInput = form.querySelector('input[name="quantity"]');
    const quantity = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    const originalLabel = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    try {
      const params = new URLSearchParams({
        id: String(variantId),
        quantity: String(quantity)
      });
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Accept': 'application/json'
        },
        body: params.toString(),
        credentials: 'same-origin'
      });
      if (!res.ok) {
        throw new Error(
          res.status === 422
            ? 'This option is unavailable or the requested quantity is out of stock.'
            : 'Could not add this product. Please try again.'
        );
      }
      // Shopify confirmed that this specific variant was added.
      // Refreshing the drawer is optional; checkout reads the server-side cart.
      try { await refreshDrawer(); } catch (_) {}
      window.location.assign('/checkout');
    } catch (err) {
      console.warn('Product checkout add failed:', err);
      setError(err && err.message
        ? err.message
        : 'Could not add this product. Please try again.');
    } finally {
      btn.disabled = false;
      btn.textContent = originalLabel;
    }
  });

  // Grid buttons: instant add for single-variant products, quick-add sheet for products with variants
// NOTE: Use delegated (capture-phase) handling so grid buttons:
// - Work even if the grid is re-rendered or inserted after initial load
// - Still run if another script hijacks the click and stops propagation
const handleGridAtcClick = async (btn) => {
  if (!btn || btn.disabled) return;

  const hasVariants = (btn.getAttribute('data-has-variants') === 'true');
  const handle = btn.getAttribute('data-product-handle');
  const title = btn.getAttribute('data-product-title') || 'Choose style';
  const variantId = btn.getAttribute('data-variant-id');

  if (!hasVariants){
    await addVariantToCart(variantId, btn);
    return;
  }

  // Variants: open quick add selector
  btn.disabled = true;
  const prevText = btn.textContent;
  btn.textContent = 'Loading…';
  try {
    const product = await fetchProduct(handle);
    quickAddState.product = product;
    quickAddState.selections = [];
    quickAddState.variant = null;
    quickAddState.sourceBtn = btn;
    if (quickAddTitle) quickAddTitle.textContent = title;
    renderOptions(product);
    // Preselect first available variant (makes it feel instant)
    const firstAvail = (product.variants || []).find(v=>v.available) || (product.variants || [])[0];
    if (firstAvail){
      const sel = [firstAvail.option1, firstAvail.option2, firstAvail.option3].filter(Boolean);
      quickAddState.selections = sel;
      // mark active
      sel.forEach((val, idx)=>{
        const b = qs(`[data-qa-opt][data-qa-idx="${idx}"][data-qa-val="${String(val).replace(/"/g,'&quot;')}"]`, quickAdd);
        if (b){
          qsa(`[data-qa-opt][data-qa-idx="${idx}"]`, quickAdd).forEach(x=>x.classList.toggle('is-active', x===b));
        }
      });
    }
    updateQuickAdd();
    openQuickAdd();
  } catch(e) {
    // If we can't load JSON, fallback to product page
    window.location.href = `/products/${handle}`;
  } finally {
    btn.disabled = false;
    btn.textContent = prevText;
  }
};

document.addEventListener('click', async (e)=>{
  const btn = e.target && e.target.closest ? e.target.closest('button[data-grid-atc]') : null;
  if (!btn) return;

  // Safety: only the actual grid CTA button should ever trigger add-to-cart.
  // This prevents accidental adds if a surrounding card, overlay, or third-party script
  // introduces broader click targets later.
  if (e && typeof e.preventDefault === 'function') e.preventDefault();
  if (e && typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
  if (e && typeof e.stopPropagation === 'function') e.stopPropagation();

  await handleGridAtcClick(btn);
}, true);

// Extra isolation for product-card CTAs: do not let button clicks bubble into card navigation.
document.addEventListener('click', (e)=>{
  const btn = e.target && e.target.closest ? e.target.closest('button[data-grid-atc]') : null;
  if (!btn) return;
  if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
}, false);

// Confirm from quick add
  if (quickAddConfirm){
    quickAddConfirm.addEventListener('click', async (e)=>{
      if (e && typeof e.preventDefault === 'function') e.preventDefault();
      const v = quickAddState.variant;
      if (!v || !v.id) return;
      quickAddConfirm.disabled = true;
      const prev = quickAddConfirm.textContent;
      quickAddConfirm.textContent = 'Adding…';
      await addVariantToCart(v.id, null);
      quickAddConfirm.textContent = prev;
      closeQuickAdd();
    });
  }

  // Mobile menu drawer (luxury slide-in + sliding submenus)
  const menuOpenBtn = qs('[data-menu-open]');
  const menuDrawer  = qs('[data-menu-drawer]');
  const menuCloseBtns = qsa('[data-menu-close]');
  const menuBackBtn = qs('[data-menu-back]');
  const menuTitleEl = qs('[data-menu-title]');
  const panelsWrap = qs('[data-menu-panels]');
  const panels = panelsWrap ? qsa('[data-menu-panel]', panelsWrap) : [];
  const openPanelBtns = qsa('[data-menu-open-panel]');

  const panelStack = ['root'];

  function setActivePanel(id){
    if (!panelsWrap) return;
    panels.forEach(p=>{
      const pid = p.getAttribute('data-menu-panel');
      p.classList.toggle('is-active', pid === id);
      p.classList.toggle('is-previous', panelStack.length > 1 && pid === panelStack[panelStack.length - 2]);
    });

    // header
    const active = panelsWrap.querySelector('[data-menu-panel].is-active');
    const parentTitle = active ? active.getAttribute('data-menu-parent-title') : null;
    if (menuTitleEl){
      menuTitleEl.textContent = parentTitle || 'Menu';
    }
    if (menuBackBtn){
      menuBackBtn.hidden = panelStack.length <= 1;
    }
  }

  function openMenu(){
    if (!menuDrawer || !menuOpenBtn) return;
    menuDrawer.setAttribute('aria-hidden','false');
    menuOpenBtn.setAttribute('aria-expanded','true');
    document.body.classList.add('menu-open');
    // reset to root
    panelStack.length = 0;
    panelStack.push('root');
    setActivePanel('root');
  }

  function closeMenu(){
    if (!menuDrawer || !menuOpenBtn) return;
    menuDrawer.setAttribute('aria-hidden','true');
    menuOpenBtn.setAttribute('aria-expanded','false');
    document.body.classList.remove('menu-open');
  }

  function goBack(){
    if (panelStack.length <= 1) return;
    panelStack.pop();
    setActivePanel(panelStack[panelStack.length - 1]);
  }

  if (menuOpenBtn && menuDrawer){
    menuOpenBtn.addEventListener('click', (e)=>{
      e.preventDefault();
      const isOpen = menuDrawer.getAttribute('aria-hidden') === 'false';
      if (isOpen) closeMenu(); else openMenu();
    });

    menuCloseBtns.forEach(btn=>{
      btn.addEventListener('click', (e)=>{
        e.preventDefault();
        closeMenu();
      });
    });

    if (menuBackBtn){
      menuBackBtn.addEventListener('click', (e)=>{
        e.preventDefault();
        goBack();
      });
    }

    openPanelBtns.forEach(btn=>{
      btn.addEventListener('click', (e)=>{
        e.preventDefault();
        const id = btn.getAttribute('data-menu-open-panel');
        if (!id) return;
        panelStack.push(id);
        setActivePanel(id);
      });
    });

    document.addEventListener('keydown', (e)=>{
      if (e.key === 'Escape'){
        if (menuDrawer.getAttribute('aria-hidden') === 'false') closeMenu();
      }
    });
  }

  // Quantity controls
  qsa('[data-qty]').forEach(wrap=>{
    const input=qs('input',wrap), dec=qs('[data-qty-dec]',wrap), inc=qs('[data-qty-inc]',wrap);
    if(!input||!dec||!inc) return;
    dec.addEventListener('click',()=>{input.value=Math.max(1,(parseInt(input.value||'1',10)-1));});
    inc.addEventListener('click',()=>{input.value=(parseInt(input.value||'1',10)+1);});
  });

  // Gallery thumbs
  const main=qs('[data-gallery-main]');
  qsa('[data-gallery-thumb]').forEach(a=>{
    a.addEventListener('click',e=>{
      if(!main) return;
      e.preventDefault();
      const src=a.getAttribute('data-src');
      if(src) main.setAttribute('src',src);

      // IMPORTANT: if main image uses srcset, update it too (otherwise the browser may keep showing the old image)
      const srcset = a.getAttribute('data-srcset');
      if (srcset) {
        main.setAttribute('srcset', srcset);
      } else {
        main.removeAttribute('srcset');
      }
      const alt = a.getAttribute('data-alt');
      if (alt) main.setAttribute('alt', alt);
      const w = a.getAttribute('data-width');
      const h = a.getAttribute('data-height');
      if (w && h) { main.setAttribute('width', w); main.setAttribute('height', h); }

      // Keep a high-res src for zoom experiences
      const zoomSrc = a.getAttribute('data-zoom-src') || src;
      if (zoomSrc && main) main.setAttribute('data-zoom-src', zoomSrc);

      // If this image corresponds to a variant image, auto-select that variant
      const mediaId = a.getAttribute('data-media-id');
      const wrap = a.closest('.product') || document;
      const select = qs('select[name="id"]', wrap);
      const jsonEl = qs('[data-variant-media-map]', wrap);
      if (select && jsonEl && mediaId){
        try {
          const map = JSON.parse(jsonEl.textContent || '[]');
          const match = map.find(v => String(v.featured_media_id) === String(mediaId));
          if (match && String(select.value) !== String(match.id)){
            select.value = String(match.id);
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } catch(err) {}
      }
    });
  });

  // Variant dropdown: change main image automatically
  const variantWrap = qs('.product');
  const variantSelect = variantWrap && qs('select[name="id"]', variantWrap);
  const variantMapEl = variantWrap && qs('[data-variant-media-map]', variantWrap);
  if (variantSelect && variantMapEl){
    let map=[];
    try { map = JSON.parse(variantMapEl.textContent || '[]'); } catch(e) { map=[]; }
    variantSelect.addEventListener('change', ()=>{
      const v = map.find(x=>String(x.id)===String(variantSelect.value));
      if (!v) return;
      // Prefer media id switch if we have thumbs; otherwise use src fallback
      if (v.featured_media_src && main) main.setAttribute('src', v.featured_media_src);
      // Reset srcset to avoid stale responsive candidates (will be re-set below if we find a matching thumb)
      if (main) main.removeAttribute('srcset');
      if (v.featured_media_zoom_src && main) main.setAttribute('data-zoom-src', v.featured_media_zoom_src);
      const thumbs = qsa('[data-gallery-thumb]');
      if (v.featured_media_id && thumbs.length){
        const t = thumbs.find(x=>String(x.getAttribute('data-media-id'))===String(v.featured_media_id));
        if (t){
          const src = t.getAttribute('data-src');
          if (src && main) main.setAttribute('src', src);
          const srcset = t.getAttribute('data-srcset');
          if (srcset && main) main.setAttribute('srcset', srcset);
          const alt = t.getAttribute('data-alt');
          if (alt && main) main.setAttribute('alt', alt);
          const w = t.getAttribute('data-width');
          const h = t.getAttribute('data-height');
          if (w && h && main) { main.setAttribute('width', w); main.setAttribute('height', h); }
          const z = t.getAttribute('data-zoom-src') || src;
          if (z && main) main.setAttribute('data-zoom-src', z);
        }
      }
    });
  }


  // Hero slide image loader:
  // Prevents hidden carousel slides from downloading until needed (keeps design the same, improves LCP/network contention).
  const loadHeroSlideImage = (slide) => {
    const img = slide && slide.querySelector && slide.querySelector('img[data-src]');
    if (!img || img.dataset.loaded === '1') return;
    const src = img.getAttribute('data-src');
    const srcset = img.getAttribute('data-srcset');
    const sizes = img.getAttribute('data-sizes');
    if (srcset) img.setAttribute('srcset', srcset);
    if (sizes) img.setAttribute('sizes', sizes);
    if (src) img.setAttribute('src', src);
    img.dataset.loaded = '1';
  };

  const initHeroCarousel = () => {
  const idle = window.requestIdleCallback || ((cb)=>setTimeout(cb, 900));
    // Hero carousel
    qsa('[data-hero-carousel]').forEach(root=>{
      const slides=qsa('[data-hero-slide]',root);
      const dots=qsa('[data-hero-dot]',root);
      const prev=qs('[data-hero-prev]',root);
      const next=qs('[data-hero-next]',root);
      if(slides.length<=1) return;
  
      let i=0;
      const show=(idx)=>{
        i=(idx+slides.length)%slides.length;
        slides.forEach((s,k)=>s.classList.toggle('active',k===i));
        dots.forEach((d,k)=>d.classList.toggle('active',k===i));
  
        // Load the active slide image if it was deferred.
        loadHeroSlideImage(slides[i]);
  
        // Warm the next slide in idle time for smooth navigation.
        idle(()=>loadHeroSlideImage(slides[(i+1)%slides.length]));
      };
      dots.forEach((d,k)=>d.addEventListener('click',()=>show(k)));
      prev && prev.addEventListener('click',()=>show(i-1));
      next && next.addEventListener('click',()=>show(i+1));
  
      // autoplay (gentle) — pause when hidden/off-screen to reduce mobile work
      let timer = null;
      let heroVisible = true;
      const stopAutoplay = () => {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      };
      const startAutoplay = () => {
        const isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
        if (isMobile || timer || document.hidden || !heroVisible) return;
        timer = setInterval(() => show(i + 1), 8000);
      };
      if ('IntersectionObserver' in window) {
        const heroIo = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            heroVisible = entry.isIntersecting;
            if (heroVisible) startAutoplay();
            else stopAutoplay();
          });
        }, { threshold: 0.15 });
        heroIo.observe(root);
      }
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      });
  
      show(0);
      startAutoplay();
    });
  
  };

  scheduleNonCritical(initHeroCarousel, 900);

  // Product description "Read more"
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-desc-toggle]');
  if (!btn) return;

  const wrap = btn.closest('.product-desc');
  const more = wrap && wrap.querySelector('[data-desc-more]');
  const preview = wrap && wrap.querySelector('[data-desc-preview]');
  if (!wrap || !more || !preview) return;

  const expanded = btn.getAttribute('aria-expanded') === 'true';

  btn.setAttribute('aria-expanded', String(!expanded));
  // Show either preview OR full description (never both)
  more.hidden = expanded;
  preview.hidden = !expanded;

  const label = btn.querySelector('.product-desc__label');
  if (label) label.textContent = expanded ? 'Read more' : 'Read less';

  wrap.classList.toggle('is-expanded', !expanded);
});


  // Cart page: live quantity updates + stock cap messaging
  const initCartPageQty = () => {
    const cartSection = qs('.cart-page');
    if (!cartSection) return;

    const inputs = qsa('input.cart-qty[data-line]', cartSection);
    if (!inputs.length) return;

    const updateLineUIFromCart = (cart, line) => {
      const item = cart.items && cart.items[line - 1];
      if (!item) return;
      const lineTotalEl = qs(`[data-line-total="${line}"]`, cartSection);
      if (lineTotalEl) lineTotalEl.textContent = formatMoney(item.final_line_price);
      const subtotalEl = qs('.cart-subtotal__value', cartSection);
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      const estimatedTotalEl = qs('[data-cart-page-estimated-total]', cartSection);
      if (estimatedTotalEl) estimatedTotalEl.textContent = formatMoney((cart.total_price || 0) + 500);
    };

    const setAvailMsg = (line, msg) => {
      const el = qs(`[data-avail-msg="${line}"]`, cartSection);
      if (!el) return;
      if (msg){
        el.textContent = msg;
        el.hidden = false;
      } else {
        el.hidden = true;
        el.textContent = '';
      }
    };

    const postChange = async (line, quantity) => {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ line, quantity })
        });
        if (!res.ok) throw new Error('cart_change_failed');
        return await res.json();
      } catch (e) {
        throw e;
      }
    };

    const timers = new Map();

    inputs.forEach((input) => {
      const line = parseInt(input.getAttribute('data-line'), 10);
      // Store last known quantity so we can restore UI state if the update fails.
      input.addEventListener('focus', () => {
        input.dataset.prevQty = String(input.value || '0');
      });

      // Ensure accessible label (product name injected from Liquid via data-product-title).
      if (!input.getAttribute('aria-label')){
        const title = input.getAttribute('data-product-title') || 'item';
        input.setAttribute('aria-label', `Quantity for ${title}`);
      }

      const schedule = () => {
        if (timers.has(input)) clearTimeout(timers.get(input));
        timers.set(input, setTimeout(async () => {
          let qty = parseInt(input.value || '0', 10);
          if (Number.isNaN(qty) || qty < 0) qty = 0;

          const max = parseInt(input.getAttribute('data-max') || '0', 10);
          if (max > 0 && qty > max){
            qty = max;
            input.value = String(max);
            setAvailMsg(line, `only ${max} available`);
          } else {
            setAvailMsg(line, '');
          }

          try{
            const cart = await postChange(line, qty);
            if (qty === 0){
              window.location.reload();
              return;
            }
            updateLineUIFromCart(cart, line);
            window.__PD_INITIAL_CART = cart;
            setCartPresenceUI(cart);
            updateWhatsAppOrderLink(cart);

            // If Shopify capped it server-side, reflect that + message
            const item = cart.items && cart.items[line - 1];
            if (item && item.quantity !== qty){
              input.value = String(item.quantity);
              setAvailMsg(line, `only ${item.quantity} available`);
            }
          }catch(e){
            // Revert to max if known, otherwise keep current value
            if (max > 0){
              input.value = String(max);
              setAvailMsg(line, `only ${max} available`);
              try{
                const cart = await postChange(line, max);
                updateLineUIFromCart(cart, line);
                window.__PD_INITIAL_CART = cart;
                setCartPresenceUI(cart);
                updateWhatsAppOrderLink(cart);
              }catch(_e){}
            }
          }
        }, 250));
      };

      input.addEventListener('change', schedule);
      input.addEventListener('input', schedule);
    });
  };
  document.addEventListener('DOMContentLoaded', initCartPageQty);

  

  // Mobile collection slider: draggable + smooth auto-loop marquee
  const initCollectionSlider = (root) => {
    const section = root && root.matches && root.matches('[data-mobile-collection-slider]')
      ? root
      : (root && root.querySelector ? root.querySelector('[data-mobile-collection-slider]') : null);
    if (!section) return;

    const track = section.querySelector('.mcs__track');
    if (!track) return;
    if (track.dataset.mcsInit === '3') return;
    track.dataset.mcsInit = '3';

    // Settings from theme editor (via data-* attrs)
    const autoscrollEnabled = String(section.dataset.autoscroll) === 'true';
    const ignoreReducedMotion = String(section.dataset.ignoreReducedMotion) === 'true';

    // Accessibility (optional override)
    const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const allowMotion = ignoreReducedMotion ? true : !prefersReduced;

    // Keep the native horizontal scroller when auto-scroll is disabled.
    // This avoids cloning nodes and running continuous animation work on mobile.
    if (!(autoscrollEnabled && allowMotion)) {
      section.classList.remove('mcs--autoscroll');
      track.dataset.mcsInit = 'static';
      return;
    }

    // Ensure markup: wrap items in an inner container we can translate smoothly
    let inner = track.querySelector('.mcs__inner');
    if (!inner) {
      inner = document.createElement('div');
      inner.className = 'mcs__inner';
      const children = Array.from(track.children);
      children.forEach((ch) => inner.appendChild(ch));
      track.appendChild(inner);
    }

    // Duplicate items once to allow seamless looping (no visible reset)
    if (inner.dataset.dup !== '1') {
      const clones = Array.from(inner.children).map((n) => n.cloneNode(true));
      clones.forEach((n) => inner.appendChild(n));
      inner.dataset.dup = '1';
    }

    section.classList.add('mcs--autoscroll');

    // Tuned px/sec so slow/medium/fast are clearly different and smooth
    const getSpeedPxPerSec = () => {
      const s = String(section.dataset.autoscrollSpeed || 'medium');
      return (s === 'slow') ? 16 : (s === 'fast' ? 52 : 30);
    };


    let halfWidth = 0;
    let offset = 0; // 0..halfWidth
    let lastTs = 0;
    
    let paused = false;
    let resumeTimer = null;
    let rafId = null;
    let intervalId = null;
    let sectionVisible = true;

    const apply = () => {
      inner.style.transform = `translate3d(${-offset}px, 0, 0)`;
    };

    const measure = () => {
      // After duplication, first half is one full loop.
      const w = inner.scrollWidth;
      halfWidth = Math.max(0, Math.floor(w / 2));
      if (halfWidth > 0) offset = offset % halfWidth;
      apply();
    };

    const pause = () => {
      paused = true;
      if (resumeTimer) clearTimeout(resumeTimer);
    };

    const resume = (delayMs = 800) => {
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => { paused = false; }, delayMs);
    };

    const step = (deltaPx) => {
      if (!halfWidth) return;
      offset += deltaPx;
      // Wrap seamlessly without a hard reset (keeps motion continuous)
      while (offset >= halfWidth) offset -= halfWidth;
      while (offset < 0) offset += halfWidth;
      apply();
    };

    const tick = (ts) => {
      if (!lastTs) lastTs = ts;
      const dt = Math.min(0.05, (ts - lastTs) / 1000); // cap dt to avoid jumps
      lastTs = ts;

      window.__mcsLastRafTs = performance.now();

      if (autoscrollEnabled && allowMotion && !paused && sectionVisible && !document.hidden) {
        step(getSpeedPxPerSec() * dt);
      }
      rafId = window.requestAnimationFrame(tick);
    };

    const startLoops = () => {
      if (rafId) cancelAnimationFrame(rafId);
      if (intervalId) clearInterval(intervalId);
      lastTs = 0;

      // RAF = smooth, interval = iOS throttling fallback
      rafId = window.requestAnimationFrame(tick);
      intervalId = window.setInterval(() => {
      if (!document.body.contains(section)) { clearInterval(intervalId); return; }
      if (!(autoscrollEnabled && allowMotion) || paused || !sectionVisible || document.hidden) return;
      // Only help when RAF is throttled (common on iOS).
      const now = performance.now();
      if (typeof window.__mcsLastRafTs === 'number' && (now - window.__mcsLastRafTs) < 220) return;
      step(getSpeedPxPerSec() * 0.05);
    }, 50);
    };

    // Drag support (keeps the swipe/drag feel)
    let isDown = false;
    let startX = 0;
    let startOffset = 0;

    const onDown = (clientX) => {
      isDown = true;
      pause();
      startX = clientX;
      startOffset = offset;
    };

    const onMove = (clientX) => {
      if (!isDown) return;
      const dx = clientX - startX;
      offset = startOffset - dx;
      if (halfWidth) {
        offset = offset % halfWidth;
        if (offset < 0) offset += halfWidth;
      }
      apply();
    };

    const onUp = () => {
      if (!isDown) return;
      isDown = false;
      resume(900);
    };

    track.addEventListener('pointerdown', (e) => {
      try { track.setPointerCapture && track.setPointerCapture(e.pointerId); } catch(_e) {}
      onDown(e.clientX);
    }, { passive: true });
    track.addEventListener('pointermove', (e) => onMove(e.clientX), { passive: true });
    track.addEventListener('pointerup', onUp, { passive: true });
    track.addEventListener('pointercancel', onUp, { passive: true });
    track.addEventListener('pointerleave', onUp, { passive: true });

    track.addEventListener('touchstart', (e) => {
      if (!e.touches || !e.touches[0]) return;
      onDown(e.touches[0].clientX);
    }, { passive: true });
    track.addEventListener('touchmove', (e) => {
      if (!e.touches || !e.touches[0]) return;
      onMove(e.touches[0].clientX);
    }, { passive: true });
    track.addEventListener('touchend', onUp, { passive: true });
    track.addEventListener('touchcancel', onUp, { passive: true });

    track.addEventListener('mouseenter', pause);
    track.addEventListener('mouseleave', () => resume(600));

    if ('IntersectionObserver' in window) {
      const visibilityIo = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          sectionVisible = entry.isIntersecting;
        });
      }, { threshold: 0.05 });
      visibilityIo.observe(section);
    }

    // Resize handling
    const ro = ('ResizeObserver' in window) ? new ResizeObserver(() => measure()) : null;
    if (ro) ro.observe(track);

    window.addEventListener('resize', measure);
    window.addEventListener('pageshow', () => { lastTs = 0; });

    // Start after layout settles (theme editor + iOS)
    setTimeout(() => {
      measure();
      startLoops();
    }, 120);
  };


  const initDeferredCollectionEnhancements = () => {
  const isSmallViewport = () => window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  
    const initAllCollectionSliders = (root=document) => {
      if (!isSmallViewport()) return;
      const sections = root.querySelectorAll ? root.querySelectorAll('[data-mobile-collection-slider]') : [];
      sections.forEach((sec)=>{
        if (sec.dataset.mcsQueued === '1') return;
        sec.dataset.mcsQueued = '1';
        const launch = () => {
          if (String(sec.dataset.autoscroll) !== 'true') return;
          initCollectionSlider(sec);
        };
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                launch();
                io.disconnect();
              }
            });
          }, { rootMargin: '200px 0px' });
          io.observe(sec);
        } else {
          const defer = window.requestIdleCallback || ((cb)=>setTimeout(cb, 250));
          defer(launch);
        }
      });
    };
  
    document.addEventListener('DOMContentLoaded', ()=>initAllCollectionSliders(document));
  
    // Theme editor: re-init when a section is re-rendered
    document.addEventListener('shopify:section:load', (e)=>{
      if (e && e.target) initAllCollectionSliders(e.target);
    });
  // iOS Safari: when navigating back/forward, the page can restore from bfcache
  // and RAF timers may not resume the same way. Re-init on pageshow.
  window.addEventListener('pageshow', () => {
    initAllCollectionSliders(document);
  });
  const reinitCollectionSlidersOnResize = debounce(() => {
    initAllCollectionSliders(document);
  }, 220);
  window.addEventListener('resize', reinitCollectionSlidersOnResize);
  
  
  };

  scheduleNonCritical(initDeferredCollectionEnhancements, 1200);

  const initDeferredEmailOffer = () => {
    // 10% Email offer popup + floating teaser
    const emailOffer = qs('[data-email-offer]');
    const emailOfferTeaser = qs('[data-email-offer-open]');
    const emailOfferStatus = qs('[data-email-offer-status]');
    const emailOfferSuccess = qs('[data-email-offer-success]');
    const emailOfferForm = qs('#PdEmailOfferForm');
    const emailOfferFormViews = qsa('[data-email-offer-form-view]');
    const emailOfferCodeScreen = qs('[data-email-offer-code-screen]');
    const emailOfferCopy = qs('[data-email-offer-copy]');
    if (!emailOffer && !emailOfferTeaser) return;

    // New storage keys intentionally ignore the old close key because many visitors/admin tests
    // may already have pd_email_offer_hidden=1 saved, which made the offer look broken forever.
    const DONE_KEY = 'pd_email_offer_v2_done';
    const HIDDEN_UNTIL_KEY = 'pd_email_offer_v2_hidden_until';
    const SUBMITTING_KEY = 'pd_email_offer_v2_submitting';
    const CODE_READY_KEY = 'pd_email_offer_v4_code_ready';
    const SUBMITTED_EMAIL_KEY = 'pd_email_offer_v4_submitted_email';
    const OLD_DONE_KEY = 'pd_email_offer_done';
    const OLD_SUBMITTING_KEY = 'pd_email_offer_submitting';
    const AUTO_OPEN_SESSION_KEY = 'pd_email_offer_v3_auto_opened_session';

    const sessionGet = (key) => {
      try { return window.sessionStorage ? window.sessionStorage.getItem(key) : null; }
      catch (_) { return null; }
    };
    const sessionSet = (key, value) => {
      try { if (window.sessionStorage) window.sessionStorage.setItem(key, value); }
      catch (_) {}
    };
    // Preserve real subscribers from the previous implementation, but do not preserve old closes.
    if (safeStorage.get(OLD_DONE_KEY) === '1') safeStorage.set(DONE_KEY, '1');
    if (safeStorage.get(OLD_SUBMITTING_KEY) === '1') {
      safeStorage.set(SUBMITTING_KEY, '1');
      safeStorage.remove(OLD_SUBMITTING_KEY);
    }

    // Customer-friendly behavior: closing the popup should not remove discount access.
    // Before subscription the CTA opens the email form; after subscription it becomes
    // a small code button so shoppers can copy WELCOME10 again while checking out.
    safeStorage.remove(HIDDEN_UNTIL_KEY);
    const isDone = () => safeStorage.get(DONE_KEY) === '1' || safeStorage.get(CODE_READY_KEY) === '1';
    const shouldBlockOffer = () => isDone();

    const setFormViewHidden = (hidden) => {
      emailOfferFormViews.forEach((el) => { el.hidden = hidden; });
    };
    const setCodeScreenVisible = (visible) => {
      if (emailOfferCodeScreen) emailOfferCodeScreen.hidden = !visible;
    };

    const emailOfferHideStatus = () => {
      if (!emailOfferStatus) return;
      emailOfferStatus.hidden = true;
      emailOfferStatus.classList.remove('is-info', 'is-success');
      emailOfferStatus.innerHTML = '';
    };
    const emailOfferShowStatus = (html, type) => {
      if (!emailOfferStatus) return;
      emailOfferStatus.innerHTML = html;
      emailOfferStatus.hidden = false;
      emailOfferStatus.classList.remove('is-info', 'is-success');
      emailOfferStatus.classList.add(type === 'success' ? 'is-success' : 'is-info');
    };
    const showTeaser = () => {
      if (!emailOfferTeaser) return;
      emailOfferTeaser.hidden = false;
      emailOfferTeaser.textContent = isDone() ? '10% CODE' : 'Get 10% OFF';
      emailOfferTeaser.setAttribute('aria-expanded', 'false');
    };
    const emailOfferClose = () => {
      if (!emailOffer) return;
      emailOffer.hidden = true;
      // Do not store a closed/hidden state for non-subscribers. The small offer button
      // must stay available so returning shoppers can still subscribe when ready.
      safeStorage.remove(HIDDEN_UNTIL_KEY);
      showTeaser();
    };
    const emailOfferShowCode = () => {
      safeStorage.set(DONE_KEY, '1');
      safeStorage.set(CODE_READY_KEY, '1');
      safeStorage.remove(HIDDEN_UNTIL_KEY);
      if (emailOffer) emailOffer.hidden = false;
      setFormViewHidden(true);
      setCodeScreenVisible(true);
      emailOfferHideStatus();
      if (emailOfferTeaser) {
        emailOfferTeaser.hidden = false;
        emailOfferTeaser.textContent = '10% CODE';
        emailOfferTeaser.setAttribute('aria-expanded', 'true');
      }
    };
    const emailOfferShowForm = () => {
      setFormViewHidden(false);
      setCodeScreenVisible(false);
      emailOfferHideStatus();
    };
    const emailOfferOpen = (force = false) => {
      if (!emailOffer) return;
      emailOffer.hidden = false;
      if (isDone()) {
        emailOfferShowCode();
        return;
      }
      emailOfferShowForm();
      if (emailOfferTeaser) {
        emailOfferTeaser.hidden = false;
        emailOfferTeaser.textContent = 'Get 10% OFF';
        emailOfferTeaser.setAttribute('aria-expanded', 'true');
      }
      const input = emailOffer.querySelector('input[type="email"]');
      if (input && force) window.setTimeout(() => input.focus(), 60);
    };
    const emailOfferMarkDone = () => {
      emailOfferShowCode();
    };

    if (emailOfferForm){
      emailOfferForm.addEventListener('submit', () => {
        const input = emailOfferForm.querySelector('input[type="email"]');
        if (input && input.value) safeStorage.set(SUBMITTED_EMAIL_KEY, input.value);
        safeStorage.set(SUBMITTING_KEY, '1');
        safeStorage.set(CODE_READY_KEY, '1');
        safeStorage.remove(HIDDEN_UNTIL_KEY);
        // Show the welcome-code state immediately so shoppers never see a second email form.
        window.setTimeout(emailOfferShowCode, 80);
      });
    }

    if (emailOfferCopy){
      emailOfferCopy.addEventListener('click', async () => {
        const code = emailOfferCopy.getAttribute('data-code') || 'WELCOME10';
        try {
          if (navigator.clipboard && navigator.clipboard.writeText){
            await navigator.clipboard.writeText(code);
            emailOfferCopy.textContent = 'Copied';
            emailOfferCopy.classList.add('is-copied');
            window.setTimeout(() => {
              emailOfferCopy.textContent = 'Copy code';
              emailOfferCopy.classList.remove('is-copied');
            }, 1600);
          }
        } catch(err) {}
      });
    }

    if (emailOfferTeaser){
      showTeaser();
      // Make the offer visible quickly as a clear CTA, even before the popup opens.
      window.setTimeout(showTeaser, 1200);
      emailOfferTeaser.addEventListener('click', () => emailOfferOpen(true));
    }

    const emailOfferParams = new URLSearchParams(window.location.search || '');
    const emailOfferSubmitted = emailOfferParams.get('customer_posted') === 'true';
    const emailOfferFormType = emailOfferParams.get('form_type') === 'customer';
    const emailOfferTags = emailOfferParams.get('contact[tags]') || '';
    const emailOfferPending = safeStorage.get(SUBMITTING_KEY) === '1';
    const emailOfferHasError = !!qs('.pd-email-offer__error');

    if (emailOfferPending || emailOfferSuccess || emailOfferSubmitted) {
      emailOfferMarkDone();
      safeStorage.remove(SUBMITTING_KEY);
      if (window.history && window.history.replaceState){
        emailOfferParams.delete('customer_posted');
        emailOfferParams.delete('form_type');
        emailOfferParams.delete('utf8');
        emailOfferParams.delete('contact[tags]');
        const next = window.location.pathname + (emailOfferParams.toString() ? '?' + emailOfferParams.toString() : '') + window.location.hash;
        window.history.replaceState({}, document.title, next);
      }
    } else if (emailOfferFormType && emailOfferTags.indexOf('pd_offer_popup') !== -1) {
      // Shopify can return the customer form again for an email that is already on the list.
      // From the shopper's point of view they subscribed, so show the code instead of another email field.
      emailOfferMarkDone();
      safeStorage.remove(SUBMITTING_KEY);
      if (window.history && window.history.replaceState){
        emailOfferParams.delete('form_type');
        emailOfferParams.delete('utf8');
        emailOfferParams.delete('contact[tags]');
        const next = window.location.pathname + (emailOfferParams.toString() ? '?' + emailOfferParams.toString() : '') + window.location.hash;
        window.history.replaceState({}, document.title, next);
      }
    } else if (emailOfferHasError) {
      safeStorage.remove(SUBMITTING_KEY);
      emailOfferOpen(true);
      emailOfferShowStatus('Please check your email address and try again.', 'info');
    }


    // Auto-open once per browser session only. If the shopper closes it, the visible
    // floating button remains available instead of disappearing for days.
    const maybeAutoOpen = () => {
      if (sessionGet(AUTO_OPEN_SESSION_KEY) === '1') return;
      if (shouldBlockOffer()) return;
      if (document.documentElement.classList.contains('pd-wa-order-modal-open')) return;
      if (document.documentElement.classList.contains('cart-drawer-open')) return;
      if (emailOffer && emailOffer.hidden === false) return;
      sessionSet(AUTO_OPEN_SESSION_KEY, '1');
      emailOfferOpen(false);
    };
    const onFirstScroll = () => {
      const doc = document.documentElement;
      const max = Math.max(1, doc.scrollHeight - window.innerHeight);
      if ((window.scrollY / max) > 0.16 || window.scrollY > 260) {
        window.removeEventListener('scroll', onFirstScroll);
        window.setTimeout(maybeAutoOpen, 800);
      }
    };
    if (!shouldBlockOffer() && !emailOfferSuccess && !emailOfferHasError) {
      window.setTimeout(maybeAutoOpen, 9000);
      window.addEventListener('scroll', onFirstScroll, { passive: true });
    }

    qsa('[data-email-offer-close]').forEach((el) => el.addEventListener('click', () => {
      emailOfferClose();
    }));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && emailOffer && emailOffer.hidden === false) {
        emailOfferClose();
      }
    });
  };

  scheduleNonCritical(initDeferredEmailOffer, 1800);

  // Collection toolbar: filter toggle, local search, sort preserving current params
  const filtersToggle = qs('[data-collection-filters-toggle]');
  const filtersPanel = qs('[data-collection-filters-panel]');
  if (filtersToggle && filtersPanel){
    filtersToggle.addEventListener('click', () => {
      const open = filtersPanel.classList.toggle('is-open');
      filtersToggle.setAttribute('aria-expanded', String(open));
    });
  }
  const collectionLocalSearch = qs('[data-collection-local-search]');
  const collectionCards = qsa('[data-collection-card]');
  const collectionEmpty = qs('[data-collection-empty]');
  const setCollectionEmptyVisible = (show) => {
    if (!collectionEmpty) return;
    collectionEmpty.textContent = show ? 'No matching items found.' : '';
    collectionEmpty.hidden = !show;
    collectionEmpty.style.display = show ? '' : 'none';
  };
  setCollectionEmptyVisible(false);
  qsa('.collection-results__empty').forEach((el) => { if (el.textContent && el.textContent.indexOf('No products match that search') !== -1) { el.textContent = ''; el.hidden = true; el.style.display = 'none'; } });
  if (collectionLocalSearch && collectionCards.length){
    collectionLocalSearch.addEventListener('input', () => {
      const q = (collectionLocalSearch.value || '').trim().toLowerCase();
      let visible = 0;
      collectionCards.forEach((card) => {
        const haystack = (card.getAttribute('data-product-search') || card.getAttribute('data-product-title') || '').toLowerCase();
        const show = !q || haystack.indexOf(q) !== -1;
        card.hidden = !show;
        if (show) visible += 1;
      });
      setCollectionEmptyVisible(!!q && visible === 0);
      const countEl = qs('[data-collection-count]');
      if (countEl) countEl.textContent = q ? `${visible} item${visible === 1 ? '' : 's'}` : countEl.getAttribute('data-original-count') || countEl.textContent;
    });
  }
  const collectionSort = qs('[data-collection-sort]');
  if (collectionSort){
    collectionSort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      if (collectionSort.value) url.searchParams.set('sort_by', collectionSort.value);
      else url.searchParams.delete('sort_by');
      window.location.href = url.toString();
    });
  }

  // Native Shopify localization selector auto-submit
  document.addEventListener('change', (e) => {
    const select = e.target && e.target.closest ? e.target.closest('[data-localization-select]') : null;
    if (!select) return;
    const form = select.closest('form');
    if (form) form.submit();
  });

  // Search scope chip active state
  qsa('.search-scope__chip input').forEach((input) => {
    input.addEventListener('change', () => {
      qsa('.search-scope__chip').forEach((chip) => chip.classList.remove('is-active'));
      const wrap = input.closest('.search-scope__chip');
      if (wrap) wrap.classList.add('is-active');
    });
  });

})();
